import type { MaybeElementRef } from "@vueuse/core";

type LongClickOptions = {
  ms?: number;
} & AddEventListenerOptions;

export function useLongClick(
  el: MaybeElementRef,
  cb: (e?: MouseEvent) => void,
  options: LongClickOptions = {}
) {
  if (import.meta.env.SSR) {
    return;
  }

  const { ms = 500, ...eventOptions } = options;
  const target = computed(() => unrefElement(el) || window);
  const timerFn = useTimeoutFn(cb, ms);

  useEventListener(
    target,
    "mousedown",
    (e?: MouseEvent) => timerFn.start(e),
    eventOptions
  );

  useEventListener(window, "mouseleave", timerFn.stop, eventOptions);
  useEventListener(window, "mouseup", timerFn.stop, eventOptions);

  useEventListener(
    target,
    "touchstart",
    (e?: MouseEvent) => timerFn.start(e),
    eventOptions
  );

  useEventListener(window, "touchend", timerFn.stop, eventOptions);
  useEventListener(window, "touchcancel", timerFn.stop, eventOptions);
  // restore original contextmenu event
  useEventListener(target, "contextmenu", cb, eventOptions);
}
